import { getSpecialGameDataByType } from '@Core/SpecialGames/SpecialGamesHelper';
import { IFreeGames } from '@GFTypes/GameStoreTypes';
import { ISpinOutcome } from '@GFTypes/GameStoreTypes/SpinOutcome';
import { ESpecialGamesType } from '@GFTypes/SpecialGames';

export const processFreeGamesSpinData = (data: ISpinOutcome): Partial<IFreeGames> | undefined => {
    const clone = structuredClone(data);
    const freeGamesResponseData = getSpecialGameDataByType(clone.specialGames, ESpecialGamesType.FREE_GAMES);

    if (!freeGamesResponseData) return undefined;

    const { triggerPositions, retriggerPositions, totalSpins, currentSpin, spinsWon } = freeGamesResponseData;

    return { totalSpins, triggerPositions, retriggerPositions, totalWin: clone.totalWin, currentSpin, spinsWon };
};
